export default __webpack_public_path__ + "static/media/404.a2163e8e.png";